import { render, staticRenderFns } from "./providerIdModal.vue?vue&type=template&id=435b629e&"
import script from "./providerIdModal.vue?vue&type=script&lang=js&"
export * from "./providerIdModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports